import React, { useState } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { API } from "./App";
import { getAuthHeader } from "./AuthRoute";

function AdminPage() {
  const [logs, setLogs] = useState([]);
  const [statusMessage, setStatusMessage] = useState("");

  // Function to handle download backup
  const handleDownloadBackup = () => {
    setStatusMessage("Launching Backup...");
    fetch(API() + "/admin/backup", {
      method: "GET",
      headers: {
        Authorization: getAuthHeader(),
      },
    })
      .then((response) => {
        if (response.status === 200) {
          return response.blob();
        } else {
          throw new Error("Failed to download backup");
        }
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `backup.zip`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setStatusMessage("Backup downloaded successfully!");
      })
      .catch((error) => {
        setStatusMessage(`Error: ${error.message}`);
      });
  };

  function handleGetLogs() {
    setLogs([]);

    fetch(API() + "/admin/logs", {
      method: "GET",
      headers: {
        Authorization: getAuthHeader(),
      },
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error("Failed to get logs");
        }
      })
      .then((data) => {
        setLogs(data);
        setStatusMessage("Logs fetched successfully!");
      })
      .catch((error) => {
        setStatusMessage(`Error: ${error.message}`);
      });
  }

  return (
    <div className="admin-page" style={{ padding: "20px" }}>
      <h2>Admin Actions</h2>

      {/* Status Message in red*/}
      <p style={{ color: "red" }}>{statusMessage}</p>

      {/* Admin Actions Grid */}

      <div
        className="admin-grid"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
          marginTop: "20px",
        }}
      >
        {/* Download Backup Card */}
        <Card
          title="Download Backup"
          style={{
            width: "300px",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            textAlign: "center",
          }}
        >
          <p>Download a backup of the server data as a JSON file.</p>
          <Button
            label="Download"
            icon="pi pi-download"
            onClick={handleDownloadBackup}
          />
        </Card>

        {/* Get logs */}
        <Card
          title="Read logs"
          style={{
            width: "300px",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            textAlign: "center",
          }}
        >
          <p>Read logs</p>
          <Button
            label={"Read logs"}
            icon={"pi pi-logs"}
            onClick={handleGetLogs}
          />
        </Card>
      </div>

      {/* Logs Display Section */}
      <div style={{ marginTop: "30px" }}>
        <h3>Logs</h3>
        <div
          style={{
            overflowY: "scroll",
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "5px",
          }}
        >
          {logs.length > 0 ? (
            logs.map((log, index) => (
              <div
                key={index}
                style={{
                  padding: "1px",
                  // backgroundColor: "#f9f9f9",
                }}
              >
                <p>
                  <strong>Date:</strong> {log.date}
                </p>
                <p>
                  <strong>Message:</strong> {log._id + " " + log.action}
                </p>
                {/* Add other log details here as needed */}
              </div>
            ))
          ) : (
            <p>No logs available. Click "Read logs" to fetch logs.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminPage;
